(function($) {
    window.c24LpCssLoaded.then(function () {

        if (!$('.mod24Tarife').length) {
            return;
        }

        contentResizer($('.mod24TarifeBlockWrapper'));

        const tarifeTooltip = $('.mod24Tarife .tooltip');
        let prevButton = null;

        if (tarifeTooltip.length > 0) {
            $.each(tarifeTooltip, function () {
                const trigger = $(this);
                const html = $('.mod24Tarife #tarife-tooltip-' + trigger.data('tooltip')).html();

                trigger.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    window.c24LpOpenPopup(html);
                });
            });
        }

        $('.c24TabButtons').each(function () {
            const tabButton = $(this);
            const tarifeContainers = $(this).parent('.mod24Tarife');
            const currentWrapper = $(this).closest('.mod24TarifeBlockWrapper');
            const allContainers = $('.mod24Tarife', currentWrapper);

            $('.tooltipInfo label', tabButton).on('click', function () {

                const tooltipContent = $(this).closest('.tooltipInfo').children('.tooltip-content');

                $('.c24TabButtons label', currentWrapper).removeClass('active');

                const allTHead = allContainers.children('thead');
                const allTBody = allContainers.children('tbody');
                const buttonName = $(this).data('button-name');
                const activeTable = tarifeContainers.filter('.' + buttonName);
                const activeTHead = $('thead', activeTable);
                const activeTBody = $('tbody', activeTable);

                $('.updateDate').each(function() {
                    if ($(this).hasClass(buttonName)) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                });

                $('.tooltip-content', currentWrapper).removeClass('active');

                $(allTHead).hide();

                if (prevButton !== this) {
                    allTBody.removeClass('loadingTariffs').hide();
                    activeTBody.addClass('loadingTariffs').show();
                } else {
                    allTBody.hide();
                    activeTBody.show();
                }

                prevButton = this;
                activeTHead.show();

                window.setTimeout(function () {
                    activeTBody.removeClass('loadingTariffs');
                }, 500);

                $('.tooltip-content', currentWrapper).hide();

                $(tarifeContainers).hide();
                $(tarifeContainers).filter('.' + buttonName).show();

                tooltipContent.show();
                tooltipContent.addClass('active');
                $(this).addClass('active');
                contentResizer(currentWrapper);

            });
        });

        // TRACKING tarife-vulink-clicked
        $('[data-efeedbacklink]').on('click', function () {
            const linkHref = $(this).data('efeedbacklink');
            const vu = $('.tarif .h3style', $(this).closest('.c24Header')).text().trim();
            let tcase = $('caption label div', $(this).closest('table')).contents().get(0);

            if (tcase) {
                tcase = tcase.nodeValue.trim() + ',';
            } else {
                tcase = $(this).closest('table').data('case') + ',';
            }

            if ($('caption label div', $(this).closest('table')).contents().get(2)) {
                tcase += ' ' + $('caption label div', $(this).closest('table')).contents().get(2)?.nodeValue?.trim() ?? '';
            }

            // track click on tariff link
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-vulink-clicked',
                tcase + ' - ' + vu + ' - ' + linkHref,
            ]);

            window.location.href = linkHref;
        });


        // TRACKING tarife-case-clicked
        // TRACKING tarife-case-tooltip-show
        $('.mod24Tarife caption .tooltipInfo').on('click', function () {

            const caseName = $('label', this).data('button-name');
            const caseDescribe = $('.tooltip-content.active', this).contents().text().trimLeft();


            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-case-tooltip-shown',
                $('.tooltip-content', this).contents().get(0).nodeValue.trim() + ' - ' + caseDescribe,
            ]);

            let combinedCaptionCase = $('label div', this).contents().get(0).nodeValue.trim() + ',';

            if ($('label div', this).contents().get(2)) {
                combinedCaptionCase += ' ' + $('label div', this).contents().get(2)?.nodeValue?.trim() ?? '';
            }

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-case-clicked',
                combinedCaptionCase + ' - ' + caseName,
            ]);
        });


        // TRACKING tarife-vu-tooltip-shown
        $('.mod24Tarife tbody .tooltip').on('click', function () {

            const name = $(this).contents().get(0).nodeValue.trim();
            const vu = $('.tarif h3', $(this).closest('.c24Header')).text().trim();
            let tcase = $('caption label div', $(this).closest('table')).contents().get(0);

            if (tcase) {
                tcase = tcase.nodeValue.trim() + ',';

            } else {
                tcase = $(this).closest('table').data('case') + ',';

            }

            if ($('caption label div', $(this).closest('table')).contents().get(2)) {
                tcase += ' ' + $('caption label div', $(this).closest('table')).contents().get(2)?.nodeValue?.trim() ?? '';
            }

            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tarife-vu-tooltip-shown',
                tcase + ' - ' + vu + ' - ' + name,
            ]);

        });

        // contentresize for button flexiblity
        function contentResizer(wrappers) {

            $.each($(wrappers), function () {

                const wrapper = $(this);
                const content = $('.tooltip-content.active', wrapper);
                const contentHeight = content.height();

                const labels = $('.c24TabButtons label', this);

                labels.css({
                    'top': contentHeight + 10,
                    'height': '',
                });

                const naturalHeights = [];

                labels.each(function () {
                    naturalHeights.push($(this).outerHeight(false));
                });

                const newHeight = Math.max(...naturalHeights);

                labels.css({
                    'height': newHeight + 2,
                });

                $('thead', this).css({
                    'margin-top': newHeight + 10 + 2,
                });

            });
        }

        $(window).resize(function () {
            contentResizer($('.mod24TarifeBlockWrapper'));
        });

    });
})(window.jQuery);
